export default class {

    /** @ngInject */
    constructor($q, requestService) {
        // todo: remove after stubs will be replaced with propper call
        this.$q = $q;
        this.urlBase = requestService.urlBase;
        this.request = requestService.request;
    }

    get() {
        return this.request('GET', `${this.urlBase}/user`);
    }

    update(data) {
        // data: (user fields)
        return this.request('PATCH', `${this.urlBase}/user`, data);
    }

    isBDN() {
        return this.request('GET', `${this.urlBase}/user/bdn`);
    }

    setBDN(isMember) {
        // data: true/false
        return this.request('POST', `${this.urlBase}/user/bdn`, {member: isMember});
    }

    getRoles() {
        return this.request('GET', `${this.urlBase}/user/roles`);
    }
}



// WEBPACK FOOTER //
// ./user/services/user.js